module.exports = __webpack_public_path__ + "static/assets/9149d98c7ab70877c624bf7c72952848.png";